import styled from 'styled-components/native'
import colors from '../../../themes/colors'

export const Subtitle = styled.Text`
  color: ${colors.primaryBlack};
  font-family: 'Lato';
  font-style: normal;
  font-size: 26px;
`
